import { render } from "./OrderHeader.vue?vue&type=template&id=77b0464a&scoped=true&ts=true"
import script from "./OrderHeader.vue?vue&type=script&lang=ts"
export * from "./OrderHeader.vue?vue&type=script&lang=ts"

import "./OrderHeader.vue?vue&type=style&index=0&id=77b0464a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b0464a"]])

export default __exports__